// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.0
//   protoc               v3.20.3
// source: analysis.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import {
  DiagnosticResultRules,
  KGObservationDataProto,
  KGObservationProto,
  NodeResultProto,
  RecommendationProto,
  TreeNodeProto,
} from "./analysis_plan";
import { ColumnHashProto, ObservationDataProto } from "./data";
import {
  AnalysisColumnType,
  analysisColumnTypeFromJSON,
  analysisColumnTypeToJSON,
  DiagnosticStatus,
  diagnosticStatusFromJSON,
  diagnosticStatusToJSON,
  OutcomeMixture,
  outcomeMixtureFromJSON,
  outcomeMixtureToJSON,
} from "./enums";
import { BenchmarkProto, FilterProto, Header, MetricProto, ObservationProto } from "./metadata";
import { DateFilter, GrowthBenchmarkProto } from "./relative_date";

export const protobufPackage = "com.meritic.newton";

/** List of the types of analysis in the system. */
export enum AnalysisType {
  /** NO_ANALYSIS_TYPE - Default value. */
  NO_ANALYSIS_TYPE = 0,
  /** METRIC_VALUE_ANALYSIS - Basic analysis to find the metric value. */
  METRIC_VALUE_ANALYSIS = 1,
  /** BENCHMARK_ANALYSIS - Compares the current metric data against a benchmark. */
  BENCHMARK_ANALYSIS = 2,
  /** DRIVER_ANALYSIS - Finds the drivers of the given metric value. */
  DRIVER_ANALYSIS = 3,
  /** CORRELATION_ANALYSIS - Finds the values of fundamentally co-related metrics. */
  CORRELATION_ANALYSIS = 4,
  /** NEW_TREE_NODE - New tree node type. */
  NEW_TREE_NODE = 5,
  UNRECOGNIZED = -1,
}

export function analysisTypeFromJSON(object: any): AnalysisType {
  switch (object) {
    case 0:
    case "NO_ANALYSIS_TYPE":
      return AnalysisType.NO_ANALYSIS_TYPE;
    case 1:
    case "METRIC_VALUE_ANALYSIS":
      return AnalysisType.METRIC_VALUE_ANALYSIS;
    case 2:
    case "BENCHMARK_ANALYSIS":
      return AnalysisType.BENCHMARK_ANALYSIS;
    case 3:
    case "DRIVER_ANALYSIS":
      return AnalysisType.DRIVER_ANALYSIS;
    case 4:
    case "CORRELATION_ANALYSIS":
      return AnalysisType.CORRELATION_ANALYSIS;
    case 5:
    case "NEW_TREE_NODE":
      return AnalysisType.NEW_TREE_NODE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return AnalysisType.UNRECOGNIZED;
  }
}

export function analysisTypeToJSON(object: AnalysisType): string {
  switch (object) {
    case AnalysisType.NO_ANALYSIS_TYPE:
      return "NO_ANALYSIS_TYPE";
    case AnalysisType.METRIC_VALUE_ANALYSIS:
      return "METRIC_VALUE_ANALYSIS";
    case AnalysisType.BENCHMARK_ANALYSIS:
      return "BENCHMARK_ANALYSIS";
    case AnalysisType.DRIVER_ANALYSIS:
      return "DRIVER_ANALYSIS";
    case AnalysisType.CORRELATION_ANALYSIS:
      return "CORRELATION_ANALYSIS";
    case AnalysisType.NEW_TREE_NODE:
      return "NEW_TREE_NODE";
    case AnalysisType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Configuration rules to generate analysis tree. */
export interface AnalysisTreeGenerationRules {
  /** Maximum depth of the analysis tree. */
  max_tree_depth?:
    | number
    | undefined;
  /**
   * Maximum number of mkg edges to traverse to generate the recommended analyses.
   * Edges are traversed in decreasing order of their weights.
   * Default value = -1 means that recommend all MKG edges.
   */
  max_mkg_edge_recommendations?:
    | number
    | undefined;
  /**
   * List of mkg edges to exclude while generating recommended analyses.
   * The header could belong to a related attribute or a fundamental relationship.
   */
  exclude_mkg_edges: Header[];
  /** Rules to capture the results for diagnostic analysis. */
  diagnostic_rules?:
    | DiagnosticResultRules
    | undefined;
  /** Rules to capture the results for variance analysis. */
  variance_rules?:
    | AnalysisTreeGenerationRules_VarianceResultRules
    | undefined;
  /** Rules to change the inherited properties of a child node. */
  inheritance_rules?: AnalysisTreeGenerationRules_NodeInheritanceRules | undefined;
}

/** Rules to capture the results for variance analysis. */
export interface AnalysisTreeGenerationRules_VarianceResultRules {
  /** TopN % of positive results to capture. */
  top_n_percentile?:
    | number
    | undefined;
  /** BottomN % of negative results to capture. */
  bottom_n_percentile?:
    | number
    | undefined;
  /**
   * Analysis column (variance, var %, var contribution) on which the
   * heuristic is applied to capture significant results.
   */
  variance_column?: AnalysisColumnType | undefined;
}

/**
 * Inheritance rules for the analysis node. Each node (except root node)
 * inherits some properties from parent node - benchmark, observation, etc.
 * Any change to these inherited properties are represented by these rules.
 */
export interface AnalysisTreeGenerationRules_NodeInheritanceRules {
  /**
   * Depth of the child node at which the inherited properties should change.
   * Allowed depth > 1.
   */
  child_node_depth?:
    | number
    | undefined;
  /** New benchmarks (growth only) to be used if the benchmark is changed. */
  new_benchmarks: GrowthBenchmarkProto[];
  /** New date filter to be used if the date range is changed. */
  new_date_filter?: DateFilter | undefined;
}

/** Representation of the MKGs used in the analysis tree node. */
export interface TreeNodeMetricProto {
  /** Id of the analysis tree node. */
  node_id?:
    | string
    | undefined;
  /** MKG inherited by the tree node containing edges which are available for recommendation. */
  inherited_mkg?:
    | MetricProto
    | undefined;
  /** MKGs of the correlated metrics analysed in the tree node containing recommendation edges only. */
  correlated_mkgs: MetricProto[];
}

/** Representation of each node in the analysis tree. */
export interface AnalysisTreeNodeProto {
  /** Id of the node. */
  id?:
    | string
    | undefined;
  /** Observation on which analysis is done. */
  observation?:
    | ObservationProto
    | undefined;
  /** Depth of the node in the analysis tree. */
  node_depth?:
    | number
    | undefined;
  /** Recommendation strings. */
  recommendation_strings: string[];
  /** Analysed data after the analysis in this node is done. */
  analysed_data?:
    | ObservationDataProto
    | undefined;
  /**
   * Results of the analysis.
   * @Deprecated: Not used by client anymore.
   */
  analysis_result?:
    | AnalysisResult
    | undefined;
  /** Ids of the child nodes in the analysis tree. */
  children_ids: string[];
  /** Type of analysis done in this node. */
  analysis_type?:
    | AnalysisType
    | undefined;
  /** Benchmark used for analysis in this node. */
  benchmark?:
    | BenchmarkProto
    | undefined;
  /** Result strings for this node which are used for commentary generation. */
  result_strings: string[];
  /** Header of the column used for driver analysis. */
  driver_header?:
    | Header
    | undefined;
  /** Header of the fundamental relationship used for correlation analysis. */
  fundamental_correlation_header?:
    | Header
    | undefined;
  /** Reference to parent node id and row index */
  parent_id?:
    | string
    | undefined;
  /** Parent recommendation used to generate this node. */
  parent_recommendation?:
    | RecommendationProto
    | undefined;
  /** Results of the analysis. */
  node_results?:
    | NodeResultProto
    | undefined;
  /** Node label. */
  node_label?:
    | string
    | undefined;
  /** kg observation */
  kg_observation?:
    | KGObservationProto
    | undefined;
  /** kg observation data */
  kg_observation_data?:
    | KGObservationDataProto
    | undefined;
  /** Analysis column hashes. */
  analysis_columns: ColumnHashProto[];
  /** Parent recommendation used to generate this node. */
  schema_options: RecommendationProto[];
  /** Grand parent recommendation which is applied in current node. */
  parent_schema_selection_id?:
    | string
    | undefined;
  /** Parent node schema id. */
  parent_node_schema_id?: string | undefined;
}

/** Representation of the analysis tree. */
export interface AnalysisTreeProto {
  /** Header of the analysis tree. */
  header?:
    | Header
    | undefined;
  /** List of filters representing the context in which the analysis tree was generated. */
  context: FilterProto[];
  /** Metric for which the analysis tree is generated. */
  metric?:
    | MetricProto
    | undefined;
  /** Id of the root node. */
  root_node_id?:
    | string
    | undefined;
  /** List of all analysis nodes in the tree. */
  nodes: AnalysisTreeNodeProto[];
  /** List of commentaries produced for this analysis tree. */
  commentaries: CommentaryProto[];
  /** List of all analysis nodes in the tree. */
  tree_nodes: TreeNodeProto[];
  /**
   * List of unique benchmarks in the tree nodes.
   * NOTE: This is used in tisa initialization when tree nodes are not fetched,
   *       but we want to show the benchmarks in the system prompt context.
   */
  node_benchmarks: BenchmarkProto[];
  /** List of question and answer. */
  insights: InsightsProto[];
}

/** Tree insights proto. */
export interface InsightsProto {
  /** Question that was asked to the analysis tree. */
  question?:
    | string
    | undefined;
  /** Answer to the question. */
  answer?: string | undefined;
}

/** Representation of a commentary corresponding to the analysis tree. */
export interface CommentaryProto {
  /** Header of the conversation from which the commentary was extracted. */
  conversation_header?:
    | Header
    | undefined;
  /** Commentary string related to the analysis. */
  commentary?:
    | string
    | undefined;
  /**
   * Validation string contains two words - "VALID/INVALID" "HIGH/MEDIUM/LOW"
   * First word represents the factual validity of the commentary.
   * Second word if the degree of confidence of the LLM in its validation.
   */
  validation?:
    | string
    | undefined;
  /**
   * External insights added to augment the commentary. These could be qualitative or quantitative
   * insights which are not present in the analysis tree.
   */
  insights?:
    | string
    | undefined;
  /** commentary configuration. */
  configuration?:
    | CommentaryProto_CommentaryConfig
    | undefined;
  /** Questions that were asked to the analysis tree. */
  questions: string[];
  /** Answers to the questions in this commentary. */
  answers: string[];
}

/** Representation of the configuration corresponding to a commentary. */
export interface CommentaryProto_CommentaryConfig {
  /** List of tree nodes selected for commentary generation. */
  selected_nodes: CommentaryProto_CommentaryConfig_SelectedNode[];
}

/** List of nodes selected for commentary generation. */
export interface CommentaryProto_CommentaryConfig_SelectedNode {
  /** Id of the tree node selected for commentary generation. */
  tree_node_id?:
    | string
    | undefined;
  /**
   * Prompt string representing the output of the selected node.
   * If this is empty, then system-generated prompt string is used for commentary.
   */
  node_prompt?: string | undefined;
}

/**
 * Representation for the result of any analysis.
 * Each analysis output can be defined separately, but the result should
 * finally be encapsulated in this proto as a common interface.
 */
export interface AnalysisResult {
  /** Type of analysis. */
  analysis_type?:
    | AnalysisType
    | undefined;
  /** Configuration to form the analysis results. */
  result_config?:
    | AnalysisResultConfig
    | undefined;
  /** One of the following should be set based on the type of analysis. */
  metric_value_analysis?: MetricValueAnalysisResult | undefined;
  benchmark_analysis?: BenchmarkAnalysisResult | undefined;
  driver_analysis?: DriverAnalysisResult | undefined;
  correlation_analysis?: CorrelationAnalysisResult | undefined;
}

/**
 * Configuration parameters used to form results of an analysis. For example -
 * Related attribute analysis can return values which form 80% of the metric
 * Target analysis can return top3 and bottom3 values for variance composition
 */
export interface AnalysisResultConfig {
  /**
   * Number of top values to choose from the analysis results.
   * If topN <= 0, then all values are considered.
   */
  top_n?:
    | number
    | undefined;
  /**
   * Number of bottom values to choose from the analysis results.
   * If bottomN <= 0, then all values are considered.
   */
  bottom_n?:
    | number
    | undefined;
  /**
   * Choose top values which form x% of the total value.
   * If topNPercent <= 0, then all values are considered.
   */
  top_n_percent?:
    | number
    | undefined;
  /** This is set to true for diagnostic analysis, and we pick the BROKEN and THRIVING results. */
  pick_diagnostic_results?: boolean | undefined;
}

/**
 * Representation of the results of metric value analysis.
 * This is a simple analysis which simply computes the value of a metric.
 */
export interface MetricValueAnalysisResult {
  /** Header of the metric. */
  metric_header?:
    | Header
    | undefined;
  /** Value of the metric. */
  metric_value?: number | undefined;
}

/**
 * Representation of the results of benchmark analysis.
 * This analysis compares the current metric data against a benchmark,
 * and finds the values which contribute significantly to the metric variance.
 */
export interface BenchmarkAnalysisResult {
  /** Header of the benchmark for which this analysis is done. */
  benchmark_header?:
    | Header
    | undefined;
  /** Results of the analysis. */
  results: BenchmarkAnalysisResult_Result[];
}

export interface BenchmarkAnalysisResult_Result {
  /** Row index in the data frame. */
  row_index?:
    | number
    | undefined;
  /** Metric value at the row index. */
  data?:
    | number
    | undefined;
  /** Benchmark value for the row index. */
  benchmark?:
    | number
    | undefined;
  /** Normalized value of the benchmark. */
  norm_benchmark?:
    | number
    | undefined;
  /** Variance of the metric value from the benchmark. */
  variance?:
    | number
    | undefined;
  /** Contribution % of the variance to the total metric variance. */
  contribution_percent?:
    | number
    | undefined;
  /** Last N-period average value if it is present in benchmark. */
  lastN_period_average?: number | undefined;
}

/**
 * Representation of the results of driver analysis.
 * This analysis finds the most significant attribute elements which are
 * driving the overall metric variance from the benchmark.
 */
export interface DriverAnalysisResult {
  /** Header of the driver attribute for which this analysis is done. */
  driver_header?:
    | Header
    | undefined;
  /** Header of the benchmark to compare against. */
  benchmark_header?:
    | Header
    | undefined;
  /** Number of unique values in the driver attribute. */
  unique_values?:
    | number
    | undefined;
  /** Results of the analysis. */
  results: DriverAnalysisResult_Result[];
  /** Indicates the mixture of outcome across all driver values. */
  mixture_result?: OutcomeMixture | undefined;
}

export interface DriverAnalysisResult_Result {
  /**
   * Value of the driver attribute.
   * Eg - "US", "Europe", "Asia" for "Region" attribute.
   */
  driver_value?:
    | string
    | undefined;
  /** Metric value for the driver attribute. */
  metric_value?:
    | number
    | undefined;
  /** Benchmark value for the driver attribute. */
  benchmark_value?:
    | number
    | undefined;
  /** Normalized value of the benchmark for the driver attribute. */
  norm_benchmark_value?:
    | number
    | undefined;
  /** Variance of the metric value from the benchmark. */
  variance?:
    | number
    | undefined;
  /** Contribution % to the variance of the total metric variance. */
  variance_contribution?:
    | number
    | undefined;
  /** Last N-period average value if it is present in benchmark. */
  lastN_period_average?:
    | number
    | undefined;
  /**
   * Diagnostic status for the driver value.
   * Valid only for diagnostic analysis.
   */
  diagnostic_result?: DiagnosticStatus | undefined;
}

/**
 * Representation of the results of correlation analysis.
 * This analysis finds the most significantly co-related metric/measure which
 * are causing an impact in the overall metric value.
 * If the correlation is formulaic, then it is contributing directly to the
 * metric variance from its benchmark.
 */
export interface CorrelationAnalysisResult {
  /** Header of the fundamental correlation. */
  correlation_header?:
    | Header
    | undefined;
  /** True if the correlation is formulaic, false otherwise. */
  is_formula?:
    | boolean
    | undefined;
  /** Formula expression string. */
  formula_expr?:
    | string
    | undefined;
  /** Results of the analysis. */
  results: CorrelationAnalysisResult_Result[];
  /** Indicates the mixture of outcome across all correlated values. */
  mixture_result?: OutcomeMixture | undefined;
}

export interface CorrelationAnalysisResult_Result {
  /** Header of the co-related metric or measure column, and their actuals vs target data. */
  related_header?: Header | undefined;
  related_value?: number | undefined;
  benchmark_value?:
    | number
    | undefined;
  /** Variance of the correlation from its benchmark. */
  variance?:
    | number
    | undefined;
  /**
   * Correlation's contribution % to the variance of the total metric variance.
   * Valid only if the correlation is formulaic.
   */
  variance_contribution?:
    | number
    | undefined;
  /** Last N-period average value if it is present in benchmark. */
  lastN_period_average?:
    | number
    | undefined;
  /**
   * Diagnostic status for the correlation.
   * Valid only for diagnostic analysis.
   */
  diagnostic_result?: DiagnosticStatus | undefined;
}

function createBaseAnalysisTreeGenerationRules(): AnalysisTreeGenerationRules {
  return {
    max_tree_depth: undefined,
    max_mkg_edge_recommendations: undefined,
    exclude_mkg_edges: [],
    diagnostic_rules: undefined,
    variance_rules: undefined,
    inheritance_rules: undefined,
  };
}

export const AnalysisTreeGenerationRules: MessageFns<AnalysisTreeGenerationRules> = {
  encode(message: AnalysisTreeGenerationRules, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.max_tree_depth !== undefined) {
      writer.uint32(8).int32(message.max_tree_depth);
    }
    if (message.max_mkg_edge_recommendations !== undefined) {
      writer.uint32(16).int32(message.max_mkg_edge_recommendations);
    }
    for (const v of message.exclude_mkg_edges) {
      Header.encode(v!, writer.uint32(26).fork()).join();
    }
    if (message.diagnostic_rules !== undefined) {
      DiagnosticResultRules.encode(message.diagnostic_rules, writer.uint32(34).fork()).join();
    }
    if (message.variance_rules !== undefined) {
      AnalysisTreeGenerationRules_VarianceResultRules.encode(message.variance_rules, writer.uint32(42).fork()).join();
    }
    if (message.inheritance_rules !== undefined) {
      AnalysisTreeGenerationRules_NodeInheritanceRules.encode(message.inheritance_rules, writer.uint32(50).fork())
        .join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AnalysisTreeGenerationRules {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAnalysisTreeGenerationRules();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.max_tree_depth = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.max_mkg_edge_recommendations = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.exclude_mkg_edges.push(Header.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.diagnostic_rules = DiagnosticResultRules.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.variance_rules = AnalysisTreeGenerationRules_VarianceResultRules.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.inheritance_rules = AnalysisTreeGenerationRules_NodeInheritanceRules.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AnalysisTreeGenerationRules {
    return {
      max_tree_depth: isSet(object.max_tree_depth) ? globalThis.Number(object.max_tree_depth) : undefined,
      max_mkg_edge_recommendations: isSet(object.max_mkg_edge_recommendations)
        ? globalThis.Number(object.max_mkg_edge_recommendations)
        : undefined,
      exclude_mkg_edges: globalThis.Array.isArray(object?.exclude_mkg_edges)
        ? object.exclude_mkg_edges.map((e: any) => Header.fromJSON(e))
        : [],
      diagnostic_rules: isSet(object.diagnostic_rules)
        ? DiagnosticResultRules.fromJSON(object.diagnostic_rules)
        : undefined,
      variance_rules: isSet(object.variance_rules)
        ? AnalysisTreeGenerationRules_VarianceResultRules.fromJSON(object.variance_rules)
        : undefined,
      inheritance_rules: isSet(object.inheritance_rules)
        ? AnalysisTreeGenerationRules_NodeInheritanceRules.fromJSON(object.inheritance_rules)
        : undefined,
    };
  },

  toJSON(message: AnalysisTreeGenerationRules): unknown {
    const obj: any = {};
    if (message.max_tree_depth !== undefined) {
      obj.max_tree_depth = Math.round(message.max_tree_depth);
    }
    if (message.max_mkg_edge_recommendations !== undefined) {
      obj.max_mkg_edge_recommendations = Math.round(message.max_mkg_edge_recommendations);
    }
    if (message.exclude_mkg_edges?.length) {
      obj.exclude_mkg_edges = message.exclude_mkg_edges.map((e) => Header.toJSON(e));
    }
    if (message.diagnostic_rules !== undefined) {
      obj.diagnostic_rules = DiagnosticResultRules.toJSON(message.diagnostic_rules);
    }
    if (message.variance_rules !== undefined) {
      obj.variance_rules = AnalysisTreeGenerationRules_VarianceResultRules.toJSON(message.variance_rules);
    }
    if (message.inheritance_rules !== undefined) {
      obj.inheritance_rules = AnalysisTreeGenerationRules_NodeInheritanceRules.toJSON(message.inheritance_rules);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AnalysisTreeGenerationRules>, I>>(base?: I): AnalysisTreeGenerationRules {
    return AnalysisTreeGenerationRules.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AnalysisTreeGenerationRules>, I>>(object: I): AnalysisTreeGenerationRules {
    const message = createBaseAnalysisTreeGenerationRules();
    message.max_tree_depth = object.max_tree_depth ?? undefined;
    message.max_mkg_edge_recommendations = object.max_mkg_edge_recommendations ?? undefined;
    message.exclude_mkg_edges = object.exclude_mkg_edges?.map((e) => Header.fromPartial(e)) || [];
    message.diagnostic_rules = (object.diagnostic_rules !== undefined && object.diagnostic_rules !== null)
      ? DiagnosticResultRules.fromPartial(object.diagnostic_rules)
      : undefined;
    message.variance_rules = (object.variance_rules !== undefined && object.variance_rules !== null)
      ? AnalysisTreeGenerationRules_VarianceResultRules.fromPartial(object.variance_rules)
      : undefined;
    message.inheritance_rules = (object.inheritance_rules !== undefined && object.inheritance_rules !== null)
      ? AnalysisTreeGenerationRules_NodeInheritanceRules.fromPartial(object.inheritance_rules)
      : undefined;
    return message;
  },
};

function createBaseAnalysisTreeGenerationRules_VarianceResultRules(): AnalysisTreeGenerationRules_VarianceResultRules {
  return { top_n_percentile: undefined, bottom_n_percentile: undefined, variance_column: undefined };
}

export const AnalysisTreeGenerationRules_VarianceResultRules: MessageFns<
  AnalysisTreeGenerationRules_VarianceResultRules
> = {
  encode(
    message: AnalysisTreeGenerationRules_VarianceResultRules,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.top_n_percentile !== undefined) {
      writer.uint32(9).double(message.top_n_percentile);
    }
    if (message.bottom_n_percentile !== undefined) {
      writer.uint32(17).double(message.bottom_n_percentile);
    }
    if (message.variance_column !== undefined) {
      writer.uint32(24).int32(message.variance_column);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AnalysisTreeGenerationRules_VarianceResultRules {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAnalysisTreeGenerationRules_VarianceResultRules();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 9) {
            break;
          }

          message.top_n_percentile = reader.double();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.bottom_n_percentile = reader.double();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.variance_column = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AnalysisTreeGenerationRules_VarianceResultRules {
    return {
      top_n_percentile: isSet(object.top_n_percentile) ? globalThis.Number(object.top_n_percentile) : undefined,
      bottom_n_percentile: isSet(object.bottom_n_percentile)
        ? globalThis.Number(object.bottom_n_percentile)
        : undefined,
      variance_column: isSet(object.variance_column) ? analysisColumnTypeFromJSON(object.variance_column) : undefined,
    };
  },

  toJSON(message: AnalysisTreeGenerationRules_VarianceResultRules): unknown {
    const obj: any = {};
    if (message.top_n_percentile !== undefined) {
      obj.top_n_percentile = message.top_n_percentile;
    }
    if (message.bottom_n_percentile !== undefined) {
      obj.bottom_n_percentile = message.bottom_n_percentile;
    }
    if (message.variance_column !== undefined) {
      obj.variance_column = analysisColumnTypeToJSON(message.variance_column);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AnalysisTreeGenerationRules_VarianceResultRules>, I>>(
    base?: I,
  ): AnalysisTreeGenerationRules_VarianceResultRules {
    return AnalysisTreeGenerationRules_VarianceResultRules.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AnalysisTreeGenerationRules_VarianceResultRules>, I>>(
    object: I,
  ): AnalysisTreeGenerationRules_VarianceResultRules {
    const message = createBaseAnalysisTreeGenerationRules_VarianceResultRules();
    message.top_n_percentile = object.top_n_percentile ?? undefined;
    message.bottom_n_percentile = object.bottom_n_percentile ?? undefined;
    message.variance_column = object.variance_column ?? undefined;
    return message;
  },
};

function createBaseAnalysisTreeGenerationRules_NodeInheritanceRules(): AnalysisTreeGenerationRules_NodeInheritanceRules {
  return { child_node_depth: undefined, new_benchmarks: [], new_date_filter: undefined };
}

export const AnalysisTreeGenerationRules_NodeInheritanceRules: MessageFns<
  AnalysisTreeGenerationRules_NodeInheritanceRules
> = {
  encode(
    message: AnalysisTreeGenerationRules_NodeInheritanceRules,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.child_node_depth !== undefined) {
      writer.uint32(8).int32(message.child_node_depth);
    }
    for (const v of message.new_benchmarks) {
      GrowthBenchmarkProto.encode(v!, writer.uint32(18).fork()).join();
    }
    if (message.new_date_filter !== undefined) {
      DateFilter.encode(message.new_date_filter, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AnalysisTreeGenerationRules_NodeInheritanceRules {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAnalysisTreeGenerationRules_NodeInheritanceRules();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.child_node_depth = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.new_benchmarks.push(GrowthBenchmarkProto.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.new_date_filter = DateFilter.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AnalysisTreeGenerationRules_NodeInheritanceRules {
    return {
      child_node_depth: isSet(object.child_node_depth) ? globalThis.Number(object.child_node_depth) : undefined,
      new_benchmarks: globalThis.Array.isArray(object?.new_benchmarks)
        ? object.new_benchmarks.map((e: any) => GrowthBenchmarkProto.fromJSON(e))
        : [],
      new_date_filter: isSet(object.new_date_filter) ? DateFilter.fromJSON(object.new_date_filter) : undefined,
    };
  },

  toJSON(message: AnalysisTreeGenerationRules_NodeInheritanceRules): unknown {
    const obj: any = {};
    if (message.child_node_depth !== undefined) {
      obj.child_node_depth = Math.round(message.child_node_depth);
    }
    if (message.new_benchmarks?.length) {
      obj.new_benchmarks = message.new_benchmarks.map((e) => GrowthBenchmarkProto.toJSON(e));
    }
    if (message.new_date_filter !== undefined) {
      obj.new_date_filter = DateFilter.toJSON(message.new_date_filter);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AnalysisTreeGenerationRules_NodeInheritanceRules>, I>>(
    base?: I,
  ): AnalysisTreeGenerationRules_NodeInheritanceRules {
    return AnalysisTreeGenerationRules_NodeInheritanceRules.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AnalysisTreeGenerationRules_NodeInheritanceRules>, I>>(
    object: I,
  ): AnalysisTreeGenerationRules_NodeInheritanceRules {
    const message = createBaseAnalysisTreeGenerationRules_NodeInheritanceRules();
    message.child_node_depth = object.child_node_depth ?? undefined;
    message.new_benchmarks = object.new_benchmarks?.map((e) => GrowthBenchmarkProto.fromPartial(e)) || [];
    message.new_date_filter = (object.new_date_filter !== undefined && object.new_date_filter !== null)
      ? DateFilter.fromPartial(object.new_date_filter)
      : undefined;
    return message;
  },
};

function createBaseTreeNodeMetricProto(): TreeNodeMetricProto {
  return { node_id: undefined, inherited_mkg: undefined, correlated_mkgs: [] };
}

export const TreeNodeMetricProto: MessageFns<TreeNodeMetricProto> = {
  encode(message: TreeNodeMetricProto, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.node_id !== undefined) {
      writer.uint32(10).string(message.node_id);
    }
    if (message.inherited_mkg !== undefined) {
      MetricProto.encode(message.inherited_mkg, writer.uint32(18).fork()).join();
    }
    for (const v of message.correlated_mkgs) {
      MetricProto.encode(v!, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TreeNodeMetricProto {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTreeNodeMetricProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.node_id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.inherited_mkg = MetricProto.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.correlated_mkgs.push(MetricProto.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TreeNodeMetricProto {
    return {
      node_id: isSet(object.node_id) ? globalThis.String(object.node_id) : undefined,
      inherited_mkg: isSet(object.inherited_mkg) ? MetricProto.fromJSON(object.inherited_mkg) : undefined,
      correlated_mkgs: globalThis.Array.isArray(object?.correlated_mkgs)
        ? object.correlated_mkgs.map((e: any) => MetricProto.fromJSON(e))
        : [],
    };
  },

  toJSON(message: TreeNodeMetricProto): unknown {
    const obj: any = {};
    if (message.node_id !== undefined) {
      obj.node_id = message.node_id;
    }
    if (message.inherited_mkg !== undefined) {
      obj.inherited_mkg = MetricProto.toJSON(message.inherited_mkg);
    }
    if (message.correlated_mkgs?.length) {
      obj.correlated_mkgs = message.correlated_mkgs.map((e) => MetricProto.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TreeNodeMetricProto>, I>>(base?: I): TreeNodeMetricProto {
    return TreeNodeMetricProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TreeNodeMetricProto>, I>>(object: I): TreeNodeMetricProto {
    const message = createBaseTreeNodeMetricProto();
    message.node_id = object.node_id ?? undefined;
    message.inherited_mkg = (object.inherited_mkg !== undefined && object.inherited_mkg !== null)
      ? MetricProto.fromPartial(object.inherited_mkg)
      : undefined;
    message.correlated_mkgs = object.correlated_mkgs?.map((e) => MetricProto.fromPartial(e)) || [];
    return message;
  },
};

function createBaseAnalysisTreeNodeProto(): AnalysisTreeNodeProto {
  return {
    id: undefined,
    observation: undefined,
    node_depth: undefined,
    recommendation_strings: [],
    analysed_data: undefined,
    analysis_result: undefined,
    children_ids: [],
    analysis_type: undefined,
    benchmark: undefined,
    result_strings: [],
    driver_header: undefined,
    fundamental_correlation_header: undefined,
    parent_id: undefined,
    parent_recommendation: undefined,
    node_results: undefined,
    node_label: undefined,
    kg_observation: undefined,
    kg_observation_data: undefined,
    analysis_columns: [],
    schema_options: [],
    parent_schema_selection_id: undefined,
    parent_node_schema_id: undefined,
  };
}

export const AnalysisTreeNodeProto: MessageFns<AnalysisTreeNodeProto> = {
  encode(message: AnalysisTreeNodeProto, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      writer.uint32(10).string(message.id);
    }
    if (message.observation !== undefined) {
      ObservationProto.encode(message.observation, writer.uint32(18).fork()).join();
    }
    if (message.node_depth !== undefined) {
      writer.uint32(24).int32(message.node_depth);
    }
    for (const v of message.recommendation_strings) {
      writer.uint32(34).string(v!);
    }
    if (message.analysed_data !== undefined) {
      ObservationDataProto.encode(message.analysed_data, writer.uint32(42).fork()).join();
    }
    if (message.analysis_result !== undefined) {
      AnalysisResult.encode(message.analysis_result, writer.uint32(50).fork()).join();
    }
    for (const v of message.children_ids) {
      writer.uint32(58).string(v!);
    }
    if (message.analysis_type !== undefined) {
      writer.uint32(64).int32(message.analysis_type);
    }
    if (message.benchmark !== undefined) {
      BenchmarkProto.encode(message.benchmark, writer.uint32(74).fork()).join();
    }
    for (const v of message.result_strings) {
      writer.uint32(82).string(v!);
    }
    if (message.driver_header !== undefined) {
      Header.encode(message.driver_header, writer.uint32(90).fork()).join();
    }
    if (message.fundamental_correlation_header !== undefined) {
      Header.encode(message.fundamental_correlation_header, writer.uint32(98).fork()).join();
    }
    if (message.parent_id !== undefined) {
      writer.uint32(106).string(message.parent_id);
    }
    if (message.parent_recommendation !== undefined) {
      RecommendationProto.encode(message.parent_recommendation, writer.uint32(114).fork()).join();
    }
    if (message.node_results !== undefined) {
      NodeResultProto.encode(message.node_results, writer.uint32(122).fork()).join();
    }
    if (message.node_label !== undefined) {
      writer.uint32(130).string(message.node_label);
    }
    if (message.kg_observation !== undefined) {
      KGObservationProto.encode(message.kg_observation, writer.uint32(138).fork()).join();
    }
    if (message.kg_observation_data !== undefined) {
      KGObservationDataProto.encode(message.kg_observation_data, writer.uint32(146).fork()).join();
    }
    for (const v of message.analysis_columns) {
      ColumnHashProto.encode(v!, writer.uint32(154).fork()).join();
    }
    for (const v of message.schema_options) {
      RecommendationProto.encode(v!, writer.uint32(162).fork()).join();
    }
    if (message.parent_schema_selection_id !== undefined) {
      writer.uint32(170).string(message.parent_schema_selection_id);
    }
    if (message.parent_node_schema_id !== undefined) {
      writer.uint32(178).string(message.parent_node_schema_id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AnalysisTreeNodeProto {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAnalysisTreeNodeProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.observation = ObservationProto.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.node_depth = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.recommendation_strings.push(reader.string());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.analysed_data = ObservationDataProto.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.analysis_result = AnalysisResult.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.children_ids.push(reader.string());
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.analysis_type = reader.int32() as any;
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.benchmark = BenchmarkProto.decode(reader, reader.uint32());
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.result_strings.push(reader.string());
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.driver_header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.fundamental_correlation_header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.parent_id = reader.string();
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.parent_recommendation = RecommendationProto.decode(reader, reader.uint32());
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.node_results = NodeResultProto.decode(reader, reader.uint32());
          continue;
        }
        case 16: {
          if (tag !== 130) {
            break;
          }

          message.node_label = reader.string();
          continue;
        }
        case 17: {
          if (tag !== 138) {
            break;
          }

          message.kg_observation = KGObservationProto.decode(reader, reader.uint32());
          continue;
        }
        case 18: {
          if (tag !== 146) {
            break;
          }

          message.kg_observation_data = KGObservationDataProto.decode(reader, reader.uint32());
          continue;
        }
        case 19: {
          if (tag !== 154) {
            break;
          }

          message.analysis_columns.push(ColumnHashProto.decode(reader, reader.uint32()));
          continue;
        }
        case 20: {
          if (tag !== 162) {
            break;
          }

          message.schema_options.push(RecommendationProto.decode(reader, reader.uint32()));
          continue;
        }
        case 21: {
          if (tag !== 170) {
            break;
          }

          message.parent_schema_selection_id = reader.string();
          continue;
        }
        case 22: {
          if (tag !== 178) {
            break;
          }

          message.parent_node_schema_id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AnalysisTreeNodeProto {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : undefined,
      observation: isSet(object.observation) ? ObservationProto.fromJSON(object.observation) : undefined,
      node_depth: isSet(object.node_depth) ? globalThis.Number(object.node_depth) : undefined,
      recommendation_strings: globalThis.Array.isArray(object?.recommendation_strings)
        ? object.recommendation_strings.map((e: any) => globalThis.String(e))
        : [],
      analysed_data: isSet(object.analysed_data) ? ObservationDataProto.fromJSON(object.analysed_data) : undefined,
      analysis_result: isSet(object.analysis_result) ? AnalysisResult.fromJSON(object.analysis_result) : undefined,
      children_ids: globalThis.Array.isArray(object?.children_ids)
        ? object.children_ids.map((e: any) => globalThis.String(e))
        : [],
      analysis_type: isSet(object.analysis_type) ? analysisTypeFromJSON(object.analysis_type) : undefined,
      benchmark: isSet(object.benchmark) ? BenchmarkProto.fromJSON(object.benchmark) : undefined,
      result_strings: globalThis.Array.isArray(object?.result_strings)
        ? object.result_strings.map((e: any) => globalThis.String(e))
        : [],
      driver_header: isSet(object.driver_header) ? Header.fromJSON(object.driver_header) : undefined,
      fundamental_correlation_header: isSet(object.fundamental_correlation_header)
        ? Header.fromJSON(object.fundamental_correlation_header)
        : undefined,
      parent_id: isSet(object.parent_id) ? globalThis.String(object.parent_id) : undefined,
      parent_recommendation: isSet(object.parent_recommendation)
        ? RecommendationProto.fromJSON(object.parent_recommendation)
        : undefined,
      node_results: isSet(object.node_results) ? NodeResultProto.fromJSON(object.node_results) : undefined,
      node_label: isSet(object.node_label) ? globalThis.String(object.node_label) : undefined,
      kg_observation: isSet(object.kg_observation) ? KGObservationProto.fromJSON(object.kg_observation) : undefined,
      kg_observation_data: isSet(object.kg_observation_data)
        ? KGObservationDataProto.fromJSON(object.kg_observation_data)
        : undefined,
      analysis_columns: globalThis.Array.isArray(object?.analysis_columns)
        ? object.analysis_columns.map((e: any) => ColumnHashProto.fromJSON(e))
        : [],
      schema_options: globalThis.Array.isArray(object?.schema_options)
        ? object.schema_options.map((e: any) => RecommendationProto.fromJSON(e))
        : [],
      parent_schema_selection_id: isSet(object.parent_schema_selection_id)
        ? globalThis.String(object.parent_schema_selection_id)
        : undefined,
      parent_node_schema_id: isSet(object.parent_node_schema_id)
        ? globalThis.String(object.parent_node_schema_id)
        : undefined,
    };
  },

  toJSON(message: AnalysisTreeNodeProto): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = message.id;
    }
    if (message.observation !== undefined) {
      obj.observation = ObservationProto.toJSON(message.observation);
    }
    if (message.node_depth !== undefined) {
      obj.node_depth = Math.round(message.node_depth);
    }
    if (message.recommendation_strings?.length) {
      obj.recommendation_strings = message.recommendation_strings;
    }
    if (message.analysed_data !== undefined) {
      obj.analysed_data = ObservationDataProto.toJSON(message.analysed_data);
    }
    if (message.analysis_result !== undefined) {
      obj.analysis_result = AnalysisResult.toJSON(message.analysis_result);
    }
    if (message.children_ids?.length) {
      obj.children_ids = message.children_ids;
    }
    if (message.analysis_type !== undefined) {
      obj.analysis_type = analysisTypeToJSON(message.analysis_type);
    }
    if (message.benchmark !== undefined) {
      obj.benchmark = BenchmarkProto.toJSON(message.benchmark);
    }
    if (message.result_strings?.length) {
      obj.result_strings = message.result_strings;
    }
    if (message.driver_header !== undefined) {
      obj.driver_header = Header.toJSON(message.driver_header);
    }
    if (message.fundamental_correlation_header !== undefined) {
      obj.fundamental_correlation_header = Header.toJSON(message.fundamental_correlation_header);
    }
    if (message.parent_id !== undefined) {
      obj.parent_id = message.parent_id;
    }
    if (message.parent_recommendation !== undefined) {
      obj.parent_recommendation = RecommendationProto.toJSON(message.parent_recommendation);
    }
    if (message.node_results !== undefined) {
      obj.node_results = NodeResultProto.toJSON(message.node_results);
    }
    if (message.node_label !== undefined) {
      obj.node_label = message.node_label;
    }
    if (message.kg_observation !== undefined) {
      obj.kg_observation = KGObservationProto.toJSON(message.kg_observation);
    }
    if (message.kg_observation_data !== undefined) {
      obj.kg_observation_data = KGObservationDataProto.toJSON(message.kg_observation_data);
    }
    if (message.analysis_columns?.length) {
      obj.analysis_columns = message.analysis_columns.map((e) => ColumnHashProto.toJSON(e));
    }
    if (message.schema_options?.length) {
      obj.schema_options = message.schema_options.map((e) => RecommendationProto.toJSON(e));
    }
    if (message.parent_schema_selection_id !== undefined) {
      obj.parent_schema_selection_id = message.parent_schema_selection_id;
    }
    if (message.parent_node_schema_id !== undefined) {
      obj.parent_node_schema_id = message.parent_node_schema_id;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AnalysisTreeNodeProto>, I>>(base?: I): AnalysisTreeNodeProto {
    return AnalysisTreeNodeProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AnalysisTreeNodeProto>, I>>(object: I): AnalysisTreeNodeProto {
    const message = createBaseAnalysisTreeNodeProto();
    message.id = object.id ?? undefined;
    message.observation = (object.observation !== undefined && object.observation !== null)
      ? ObservationProto.fromPartial(object.observation)
      : undefined;
    message.node_depth = object.node_depth ?? undefined;
    message.recommendation_strings = object.recommendation_strings?.map((e) => e) || [];
    message.analysed_data = (object.analysed_data !== undefined && object.analysed_data !== null)
      ? ObservationDataProto.fromPartial(object.analysed_data)
      : undefined;
    message.analysis_result = (object.analysis_result !== undefined && object.analysis_result !== null)
      ? AnalysisResult.fromPartial(object.analysis_result)
      : undefined;
    message.children_ids = object.children_ids?.map((e) => e) || [];
    message.analysis_type = object.analysis_type ?? undefined;
    message.benchmark = (object.benchmark !== undefined && object.benchmark !== null)
      ? BenchmarkProto.fromPartial(object.benchmark)
      : undefined;
    message.result_strings = object.result_strings?.map((e) => e) || [];
    message.driver_header = (object.driver_header !== undefined && object.driver_header !== null)
      ? Header.fromPartial(object.driver_header)
      : undefined;
    message.fundamental_correlation_header =
      (object.fundamental_correlation_header !== undefined && object.fundamental_correlation_header !== null)
        ? Header.fromPartial(object.fundamental_correlation_header)
        : undefined;
    message.parent_id = object.parent_id ?? undefined;
    message.parent_recommendation =
      (object.parent_recommendation !== undefined && object.parent_recommendation !== null)
        ? RecommendationProto.fromPartial(object.parent_recommendation)
        : undefined;
    message.node_results = (object.node_results !== undefined && object.node_results !== null)
      ? NodeResultProto.fromPartial(object.node_results)
      : undefined;
    message.node_label = object.node_label ?? undefined;
    message.kg_observation = (object.kg_observation !== undefined && object.kg_observation !== null)
      ? KGObservationProto.fromPartial(object.kg_observation)
      : undefined;
    message.kg_observation_data = (object.kg_observation_data !== undefined && object.kg_observation_data !== null)
      ? KGObservationDataProto.fromPartial(object.kg_observation_data)
      : undefined;
    message.analysis_columns = object.analysis_columns?.map((e) => ColumnHashProto.fromPartial(e)) || [];
    message.schema_options = object.schema_options?.map((e) => RecommendationProto.fromPartial(e)) || [];
    message.parent_schema_selection_id = object.parent_schema_selection_id ?? undefined;
    message.parent_node_schema_id = object.parent_node_schema_id ?? undefined;
    return message;
  },
};

function createBaseAnalysisTreeProto(): AnalysisTreeProto {
  return {
    header: undefined,
    context: [],
    metric: undefined,
    root_node_id: undefined,
    nodes: [],
    commentaries: [],
    tree_nodes: [],
    node_benchmarks: [],
    insights: [],
  };
}

export const AnalysisTreeProto: MessageFns<AnalysisTreeProto> = {
  encode(message: AnalysisTreeProto, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      Header.encode(message.header, writer.uint32(10).fork()).join();
    }
    for (const v of message.context) {
      FilterProto.encode(v!, writer.uint32(18).fork()).join();
    }
    if (message.metric !== undefined) {
      MetricProto.encode(message.metric, writer.uint32(26).fork()).join();
    }
    if (message.root_node_id !== undefined) {
      writer.uint32(34).string(message.root_node_id);
    }
    for (const v of message.nodes) {
      AnalysisTreeNodeProto.encode(v!, writer.uint32(42).fork()).join();
    }
    for (const v of message.commentaries) {
      CommentaryProto.encode(v!, writer.uint32(50).fork()).join();
    }
    for (const v of message.tree_nodes) {
      TreeNodeProto.encode(v!, writer.uint32(58).fork()).join();
    }
    for (const v of message.node_benchmarks) {
      BenchmarkProto.encode(v!, writer.uint32(66).fork()).join();
    }
    for (const v of message.insights) {
      InsightsProto.encode(v!, writer.uint32(74).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AnalysisTreeProto {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAnalysisTreeProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.context.push(FilterProto.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.metric = MetricProto.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.root_node_id = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.nodes.push(AnalysisTreeNodeProto.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.commentaries.push(CommentaryProto.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.tree_nodes.push(TreeNodeProto.decode(reader, reader.uint32()));
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.node_benchmarks.push(BenchmarkProto.decode(reader, reader.uint32()));
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.insights.push(InsightsProto.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AnalysisTreeProto {
    return {
      header: isSet(object.header) ? Header.fromJSON(object.header) : undefined,
      context: globalThis.Array.isArray(object?.context) ? object.context.map((e: any) => FilterProto.fromJSON(e)) : [],
      metric: isSet(object.metric) ? MetricProto.fromJSON(object.metric) : undefined,
      root_node_id: isSet(object.root_node_id) ? globalThis.String(object.root_node_id) : undefined,
      nodes: globalThis.Array.isArray(object?.nodes)
        ? object.nodes.map((e: any) => AnalysisTreeNodeProto.fromJSON(e))
        : [],
      commentaries: globalThis.Array.isArray(object?.commentaries)
        ? object.commentaries.map((e: any) => CommentaryProto.fromJSON(e))
        : [],
      tree_nodes: globalThis.Array.isArray(object?.tree_nodes)
        ? object.tree_nodes.map((e: any) => TreeNodeProto.fromJSON(e))
        : [],
      node_benchmarks: globalThis.Array.isArray(object?.node_benchmarks)
        ? object.node_benchmarks.map((e: any) => BenchmarkProto.fromJSON(e))
        : [],
      insights: globalThis.Array.isArray(object?.insights)
        ? object.insights.map((e: any) => InsightsProto.fromJSON(e))
        : [],
    };
  },

  toJSON(message: AnalysisTreeProto): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = Header.toJSON(message.header);
    }
    if (message.context?.length) {
      obj.context = message.context.map((e) => FilterProto.toJSON(e));
    }
    if (message.metric !== undefined) {
      obj.metric = MetricProto.toJSON(message.metric);
    }
    if (message.root_node_id !== undefined) {
      obj.root_node_id = message.root_node_id;
    }
    if (message.nodes?.length) {
      obj.nodes = message.nodes.map((e) => AnalysisTreeNodeProto.toJSON(e));
    }
    if (message.commentaries?.length) {
      obj.commentaries = message.commentaries.map((e) => CommentaryProto.toJSON(e));
    }
    if (message.tree_nodes?.length) {
      obj.tree_nodes = message.tree_nodes.map((e) => TreeNodeProto.toJSON(e));
    }
    if (message.node_benchmarks?.length) {
      obj.node_benchmarks = message.node_benchmarks.map((e) => BenchmarkProto.toJSON(e));
    }
    if (message.insights?.length) {
      obj.insights = message.insights.map((e) => InsightsProto.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AnalysisTreeProto>, I>>(base?: I): AnalysisTreeProto {
    return AnalysisTreeProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AnalysisTreeProto>, I>>(object: I): AnalysisTreeProto {
    const message = createBaseAnalysisTreeProto();
    message.header = (object.header !== undefined && object.header !== null)
      ? Header.fromPartial(object.header)
      : undefined;
    message.context = object.context?.map((e) => FilterProto.fromPartial(e)) || [];
    message.metric = (object.metric !== undefined && object.metric !== null)
      ? MetricProto.fromPartial(object.metric)
      : undefined;
    message.root_node_id = object.root_node_id ?? undefined;
    message.nodes = object.nodes?.map((e) => AnalysisTreeNodeProto.fromPartial(e)) || [];
    message.commentaries = object.commentaries?.map((e) => CommentaryProto.fromPartial(e)) || [];
    message.tree_nodes = object.tree_nodes?.map((e) => TreeNodeProto.fromPartial(e)) || [];
    message.node_benchmarks = object.node_benchmarks?.map((e) => BenchmarkProto.fromPartial(e)) || [];
    message.insights = object.insights?.map((e) => InsightsProto.fromPartial(e)) || [];
    return message;
  },
};

function createBaseInsightsProto(): InsightsProto {
  return { question: undefined, answer: undefined };
}

export const InsightsProto: MessageFns<InsightsProto> = {
  encode(message: InsightsProto, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.question !== undefined) {
      writer.uint32(10).string(message.question);
    }
    if (message.answer !== undefined) {
      writer.uint32(18).string(message.answer);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): InsightsProto {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInsightsProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.question = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.answer = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): InsightsProto {
    return {
      question: isSet(object.question) ? globalThis.String(object.question) : undefined,
      answer: isSet(object.answer) ? globalThis.String(object.answer) : undefined,
    };
  },

  toJSON(message: InsightsProto): unknown {
    const obj: any = {};
    if (message.question !== undefined) {
      obj.question = message.question;
    }
    if (message.answer !== undefined) {
      obj.answer = message.answer;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<InsightsProto>, I>>(base?: I): InsightsProto {
    return InsightsProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<InsightsProto>, I>>(object: I): InsightsProto {
    const message = createBaseInsightsProto();
    message.question = object.question ?? undefined;
    message.answer = object.answer ?? undefined;
    return message;
  },
};

function createBaseCommentaryProto(): CommentaryProto {
  return {
    conversation_header: undefined,
    commentary: undefined,
    validation: undefined,
    insights: undefined,
    configuration: undefined,
    questions: [],
    answers: [],
  };
}

export const CommentaryProto: MessageFns<CommentaryProto> = {
  encode(message: CommentaryProto, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.conversation_header !== undefined) {
      Header.encode(message.conversation_header, writer.uint32(10).fork()).join();
    }
    if (message.commentary !== undefined) {
      writer.uint32(18).string(message.commentary);
    }
    if (message.validation !== undefined) {
      writer.uint32(26).string(message.validation);
    }
    if (message.insights !== undefined) {
      writer.uint32(34).string(message.insights);
    }
    if (message.configuration !== undefined) {
      CommentaryProto_CommentaryConfig.encode(message.configuration, writer.uint32(42).fork()).join();
    }
    for (const v of message.questions) {
      writer.uint32(50).string(v!);
    }
    for (const v of message.answers) {
      writer.uint32(58).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CommentaryProto {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCommentaryProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.conversation_header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.commentary = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.validation = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.insights = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.configuration = CommentaryProto_CommentaryConfig.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.questions.push(reader.string());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.answers.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CommentaryProto {
    return {
      conversation_header: isSet(object.conversation_header) ? Header.fromJSON(object.conversation_header) : undefined,
      commentary: isSet(object.commentary) ? globalThis.String(object.commentary) : undefined,
      validation: isSet(object.validation) ? globalThis.String(object.validation) : undefined,
      insights: isSet(object.insights) ? globalThis.String(object.insights) : undefined,
      configuration: isSet(object.configuration)
        ? CommentaryProto_CommentaryConfig.fromJSON(object.configuration)
        : undefined,
      questions: globalThis.Array.isArray(object?.questions)
        ? object.questions.map((e: any) => globalThis.String(e))
        : [],
      answers: globalThis.Array.isArray(object?.answers) ? object.answers.map((e: any) => globalThis.String(e)) : [],
    };
  },

  toJSON(message: CommentaryProto): unknown {
    const obj: any = {};
    if (message.conversation_header !== undefined) {
      obj.conversation_header = Header.toJSON(message.conversation_header);
    }
    if (message.commentary !== undefined) {
      obj.commentary = message.commentary;
    }
    if (message.validation !== undefined) {
      obj.validation = message.validation;
    }
    if (message.insights !== undefined) {
      obj.insights = message.insights;
    }
    if (message.configuration !== undefined) {
      obj.configuration = CommentaryProto_CommentaryConfig.toJSON(message.configuration);
    }
    if (message.questions?.length) {
      obj.questions = message.questions;
    }
    if (message.answers?.length) {
      obj.answers = message.answers;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CommentaryProto>, I>>(base?: I): CommentaryProto {
    return CommentaryProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CommentaryProto>, I>>(object: I): CommentaryProto {
    const message = createBaseCommentaryProto();
    message.conversation_header = (object.conversation_header !== undefined && object.conversation_header !== null)
      ? Header.fromPartial(object.conversation_header)
      : undefined;
    message.commentary = object.commentary ?? undefined;
    message.validation = object.validation ?? undefined;
    message.insights = object.insights ?? undefined;
    message.configuration = (object.configuration !== undefined && object.configuration !== null)
      ? CommentaryProto_CommentaryConfig.fromPartial(object.configuration)
      : undefined;
    message.questions = object.questions?.map((e) => e) || [];
    message.answers = object.answers?.map((e) => e) || [];
    return message;
  },
};

function createBaseCommentaryProto_CommentaryConfig(): CommentaryProto_CommentaryConfig {
  return { selected_nodes: [] };
}

export const CommentaryProto_CommentaryConfig: MessageFns<CommentaryProto_CommentaryConfig> = {
  encode(message: CommentaryProto_CommentaryConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.selected_nodes) {
      CommentaryProto_CommentaryConfig_SelectedNode.encode(v!, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CommentaryProto_CommentaryConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCommentaryProto_CommentaryConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.selected_nodes.push(CommentaryProto_CommentaryConfig_SelectedNode.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CommentaryProto_CommentaryConfig {
    return {
      selected_nodes: globalThis.Array.isArray(object?.selected_nodes)
        ? object.selected_nodes.map((e: any) => CommentaryProto_CommentaryConfig_SelectedNode.fromJSON(e))
        : [],
    };
  },

  toJSON(message: CommentaryProto_CommentaryConfig): unknown {
    const obj: any = {};
    if (message.selected_nodes?.length) {
      obj.selected_nodes = message.selected_nodes.map((e) => CommentaryProto_CommentaryConfig_SelectedNode.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CommentaryProto_CommentaryConfig>, I>>(
    base?: I,
  ): CommentaryProto_CommentaryConfig {
    return CommentaryProto_CommentaryConfig.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CommentaryProto_CommentaryConfig>, I>>(
    object: I,
  ): CommentaryProto_CommentaryConfig {
    const message = createBaseCommentaryProto_CommentaryConfig();
    message.selected_nodes =
      object.selected_nodes?.map((e) => CommentaryProto_CommentaryConfig_SelectedNode.fromPartial(e)) || [];
    return message;
  },
};

function createBaseCommentaryProto_CommentaryConfig_SelectedNode(): CommentaryProto_CommentaryConfig_SelectedNode {
  return { tree_node_id: undefined, node_prompt: undefined };
}

export const CommentaryProto_CommentaryConfig_SelectedNode: MessageFns<CommentaryProto_CommentaryConfig_SelectedNode> =
  {
    encode(
      message: CommentaryProto_CommentaryConfig_SelectedNode,
      writer: BinaryWriter = new BinaryWriter(),
    ): BinaryWriter {
      if (message.tree_node_id !== undefined) {
        writer.uint32(10).string(message.tree_node_id);
      }
      if (message.node_prompt !== undefined) {
        writer.uint32(18).string(message.node_prompt);
      }
      return writer;
    },

    decode(input: BinaryReader | Uint8Array, length?: number): CommentaryProto_CommentaryConfig_SelectedNode {
      const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
      let end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseCommentaryProto_CommentaryConfig_SelectedNode();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.tree_node_id = reader.string();
            continue;
          }
          case 2: {
            if (tag !== 18) {
              break;
            }

            message.node_prompt = reader.string();
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    },

    fromJSON(object: any): CommentaryProto_CommentaryConfig_SelectedNode {
      return {
        tree_node_id: isSet(object.tree_node_id) ? globalThis.String(object.tree_node_id) : undefined,
        node_prompt: isSet(object.node_prompt) ? globalThis.String(object.node_prompt) : undefined,
      };
    },

    toJSON(message: CommentaryProto_CommentaryConfig_SelectedNode): unknown {
      const obj: any = {};
      if (message.tree_node_id !== undefined) {
        obj.tree_node_id = message.tree_node_id;
      }
      if (message.node_prompt !== undefined) {
        obj.node_prompt = message.node_prompt;
      }
      return obj;
    },

    create<I extends Exact<DeepPartial<CommentaryProto_CommentaryConfig_SelectedNode>, I>>(
      base?: I,
    ): CommentaryProto_CommentaryConfig_SelectedNode {
      return CommentaryProto_CommentaryConfig_SelectedNode.fromPartial(base ?? ({} as any));
    },
    fromPartial<I extends Exact<DeepPartial<CommentaryProto_CommentaryConfig_SelectedNode>, I>>(
      object: I,
    ): CommentaryProto_CommentaryConfig_SelectedNode {
      const message = createBaseCommentaryProto_CommentaryConfig_SelectedNode();
      message.tree_node_id = object.tree_node_id ?? undefined;
      message.node_prompt = object.node_prompt ?? undefined;
      return message;
    },
  };

function createBaseAnalysisResult(): AnalysisResult {
  return {
    analysis_type: undefined,
    result_config: undefined,
    metric_value_analysis: undefined,
    benchmark_analysis: undefined,
    driver_analysis: undefined,
    correlation_analysis: undefined,
  };
}

export const AnalysisResult: MessageFns<AnalysisResult> = {
  encode(message: AnalysisResult, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.analysis_type !== undefined) {
      writer.uint32(8).int32(message.analysis_type);
    }
    if (message.result_config !== undefined) {
      AnalysisResultConfig.encode(message.result_config, writer.uint32(18).fork()).join();
    }
    if (message.metric_value_analysis !== undefined) {
      MetricValueAnalysisResult.encode(message.metric_value_analysis, writer.uint32(26).fork()).join();
    }
    if (message.benchmark_analysis !== undefined) {
      BenchmarkAnalysisResult.encode(message.benchmark_analysis, writer.uint32(34).fork()).join();
    }
    if (message.driver_analysis !== undefined) {
      DriverAnalysisResult.encode(message.driver_analysis, writer.uint32(42).fork()).join();
    }
    if (message.correlation_analysis !== undefined) {
      CorrelationAnalysisResult.encode(message.correlation_analysis, writer.uint32(50).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AnalysisResult {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAnalysisResult();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.analysis_type = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.result_config = AnalysisResultConfig.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.metric_value_analysis = MetricValueAnalysisResult.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.benchmark_analysis = BenchmarkAnalysisResult.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.driver_analysis = DriverAnalysisResult.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.correlation_analysis = CorrelationAnalysisResult.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AnalysisResult {
    return {
      analysis_type: isSet(object.analysis_type) ? analysisTypeFromJSON(object.analysis_type) : undefined,
      result_config: isSet(object.result_config) ? AnalysisResultConfig.fromJSON(object.result_config) : undefined,
      metric_value_analysis: isSet(object.metric_value_analysis)
        ? MetricValueAnalysisResult.fromJSON(object.metric_value_analysis)
        : undefined,
      benchmark_analysis: isSet(object.benchmark_analysis)
        ? BenchmarkAnalysisResult.fromJSON(object.benchmark_analysis)
        : undefined,
      driver_analysis: isSet(object.driver_analysis)
        ? DriverAnalysisResult.fromJSON(object.driver_analysis)
        : undefined,
      correlation_analysis: isSet(object.correlation_analysis)
        ? CorrelationAnalysisResult.fromJSON(object.correlation_analysis)
        : undefined,
    };
  },

  toJSON(message: AnalysisResult): unknown {
    const obj: any = {};
    if (message.analysis_type !== undefined) {
      obj.analysis_type = analysisTypeToJSON(message.analysis_type);
    }
    if (message.result_config !== undefined) {
      obj.result_config = AnalysisResultConfig.toJSON(message.result_config);
    }
    if (message.metric_value_analysis !== undefined) {
      obj.metric_value_analysis = MetricValueAnalysisResult.toJSON(message.metric_value_analysis);
    }
    if (message.benchmark_analysis !== undefined) {
      obj.benchmark_analysis = BenchmarkAnalysisResult.toJSON(message.benchmark_analysis);
    }
    if (message.driver_analysis !== undefined) {
      obj.driver_analysis = DriverAnalysisResult.toJSON(message.driver_analysis);
    }
    if (message.correlation_analysis !== undefined) {
      obj.correlation_analysis = CorrelationAnalysisResult.toJSON(message.correlation_analysis);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AnalysisResult>, I>>(base?: I): AnalysisResult {
    return AnalysisResult.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AnalysisResult>, I>>(object: I): AnalysisResult {
    const message = createBaseAnalysisResult();
    message.analysis_type = object.analysis_type ?? undefined;
    message.result_config = (object.result_config !== undefined && object.result_config !== null)
      ? AnalysisResultConfig.fromPartial(object.result_config)
      : undefined;
    message.metric_value_analysis =
      (object.metric_value_analysis !== undefined && object.metric_value_analysis !== null)
        ? MetricValueAnalysisResult.fromPartial(object.metric_value_analysis)
        : undefined;
    message.benchmark_analysis = (object.benchmark_analysis !== undefined && object.benchmark_analysis !== null)
      ? BenchmarkAnalysisResult.fromPartial(object.benchmark_analysis)
      : undefined;
    message.driver_analysis = (object.driver_analysis !== undefined && object.driver_analysis !== null)
      ? DriverAnalysisResult.fromPartial(object.driver_analysis)
      : undefined;
    message.correlation_analysis = (object.correlation_analysis !== undefined && object.correlation_analysis !== null)
      ? CorrelationAnalysisResult.fromPartial(object.correlation_analysis)
      : undefined;
    return message;
  },
};

function createBaseAnalysisResultConfig(): AnalysisResultConfig {
  return { top_n: undefined, bottom_n: undefined, top_n_percent: undefined, pick_diagnostic_results: undefined };
}

export const AnalysisResultConfig: MessageFns<AnalysisResultConfig> = {
  encode(message: AnalysisResultConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.top_n !== undefined) {
      writer.uint32(8).int32(message.top_n);
    }
    if (message.bottom_n !== undefined) {
      writer.uint32(16).int32(message.bottom_n);
    }
    if (message.top_n_percent !== undefined) {
      writer.uint32(25).double(message.top_n_percent);
    }
    if (message.pick_diagnostic_results !== undefined) {
      writer.uint32(32).bool(message.pick_diagnostic_results);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AnalysisResultConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAnalysisResultConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.top_n = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.bottom_n = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 25) {
            break;
          }

          message.top_n_percent = reader.double();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.pick_diagnostic_results = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AnalysisResultConfig {
    return {
      top_n: isSet(object.top_n) ? globalThis.Number(object.top_n) : undefined,
      bottom_n: isSet(object.bottom_n) ? globalThis.Number(object.bottom_n) : undefined,
      top_n_percent: isSet(object.top_n_percent) ? globalThis.Number(object.top_n_percent) : undefined,
      pick_diagnostic_results: isSet(object.pick_diagnostic_results)
        ? globalThis.Boolean(object.pick_diagnostic_results)
        : undefined,
    };
  },

  toJSON(message: AnalysisResultConfig): unknown {
    const obj: any = {};
    if (message.top_n !== undefined) {
      obj.top_n = Math.round(message.top_n);
    }
    if (message.bottom_n !== undefined) {
      obj.bottom_n = Math.round(message.bottom_n);
    }
    if (message.top_n_percent !== undefined) {
      obj.top_n_percent = message.top_n_percent;
    }
    if (message.pick_diagnostic_results !== undefined) {
      obj.pick_diagnostic_results = message.pick_diagnostic_results;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AnalysisResultConfig>, I>>(base?: I): AnalysisResultConfig {
    return AnalysisResultConfig.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AnalysisResultConfig>, I>>(object: I): AnalysisResultConfig {
    const message = createBaseAnalysisResultConfig();
    message.top_n = object.top_n ?? undefined;
    message.bottom_n = object.bottom_n ?? undefined;
    message.top_n_percent = object.top_n_percent ?? undefined;
    message.pick_diagnostic_results = object.pick_diagnostic_results ?? undefined;
    return message;
  },
};

function createBaseMetricValueAnalysisResult(): MetricValueAnalysisResult {
  return { metric_header: undefined, metric_value: undefined };
}

export const MetricValueAnalysisResult: MessageFns<MetricValueAnalysisResult> = {
  encode(message: MetricValueAnalysisResult, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.metric_header !== undefined) {
      Header.encode(message.metric_header, writer.uint32(10).fork()).join();
    }
    if (message.metric_value !== undefined) {
      writer.uint32(17).double(message.metric_value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MetricValueAnalysisResult {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMetricValueAnalysisResult();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.metric_header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.metric_value = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MetricValueAnalysisResult {
    return {
      metric_header: isSet(object.metric_header) ? Header.fromJSON(object.metric_header) : undefined,
      metric_value: isSet(object.metric_value) ? globalThis.Number(object.metric_value) : undefined,
    };
  },

  toJSON(message: MetricValueAnalysisResult): unknown {
    const obj: any = {};
    if (message.metric_header !== undefined) {
      obj.metric_header = Header.toJSON(message.metric_header);
    }
    if (message.metric_value !== undefined) {
      obj.metric_value = message.metric_value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MetricValueAnalysisResult>, I>>(base?: I): MetricValueAnalysisResult {
    return MetricValueAnalysisResult.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MetricValueAnalysisResult>, I>>(object: I): MetricValueAnalysisResult {
    const message = createBaseMetricValueAnalysisResult();
    message.metric_header = (object.metric_header !== undefined && object.metric_header !== null)
      ? Header.fromPartial(object.metric_header)
      : undefined;
    message.metric_value = object.metric_value ?? undefined;
    return message;
  },
};

function createBaseBenchmarkAnalysisResult(): BenchmarkAnalysisResult {
  return { benchmark_header: undefined, results: [] };
}

export const BenchmarkAnalysisResult: MessageFns<BenchmarkAnalysisResult> = {
  encode(message: BenchmarkAnalysisResult, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.benchmark_header !== undefined) {
      Header.encode(message.benchmark_header, writer.uint32(10).fork()).join();
    }
    for (const v of message.results) {
      BenchmarkAnalysisResult_Result.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BenchmarkAnalysisResult {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBenchmarkAnalysisResult();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.benchmark_header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.results.push(BenchmarkAnalysisResult_Result.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BenchmarkAnalysisResult {
    return {
      benchmark_header: isSet(object.benchmark_header) ? Header.fromJSON(object.benchmark_header) : undefined,
      results: globalThis.Array.isArray(object?.results)
        ? object.results.map((e: any) => BenchmarkAnalysisResult_Result.fromJSON(e))
        : [],
    };
  },

  toJSON(message: BenchmarkAnalysisResult): unknown {
    const obj: any = {};
    if (message.benchmark_header !== undefined) {
      obj.benchmark_header = Header.toJSON(message.benchmark_header);
    }
    if (message.results?.length) {
      obj.results = message.results.map((e) => BenchmarkAnalysisResult_Result.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BenchmarkAnalysisResult>, I>>(base?: I): BenchmarkAnalysisResult {
    return BenchmarkAnalysisResult.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BenchmarkAnalysisResult>, I>>(object: I): BenchmarkAnalysisResult {
    const message = createBaseBenchmarkAnalysisResult();
    message.benchmark_header = (object.benchmark_header !== undefined && object.benchmark_header !== null)
      ? Header.fromPartial(object.benchmark_header)
      : undefined;
    message.results = object.results?.map((e) => BenchmarkAnalysisResult_Result.fromPartial(e)) || [];
    return message;
  },
};

function createBaseBenchmarkAnalysisResult_Result(): BenchmarkAnalysisResult_Result {
  return {
    row_index: undefined,
    data: undefined,
    benchmark: undefined,
    norm_benchmark: undefined,
    variance: undefined,
    contribution_percent: undefined,
    lastN_period_average: undefined,
  };
}

export const BenchmarkAnalysisResult_Result: MessageFns<BenchmarkAnalysisResult_Result> = {
  encode(message: BenchmarkAnalysisResult_Result, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.row_index !== undefined) {
      writer.uint32(8).int32(message.row_index);
    }
    if (message.data !== undefined) {
      writer.uint32(17).double(message.data);
    }
    if (message.benchmark !== undefined) {
      writer.uint32(25).double(message.benchmark);
    }
    if (message.norm_benchmark !== undefined) {
      writer.uint32(33).double(message.norm_benchmark);
    }
    if (message.variance !== undefined) {
      writer.uint32(41).double(message.variance);
    }
    if (message.contribution_percent !== undefined) {
      writer.uint32(49).double(message.contribution_percent);
    }
    if (message.lastN_period_average !== undefined) {
      writer.uint32(57).double(message.lastN_period_average);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BenchmarkAnalysisResult_Result {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBenchmarkAnalysisResult_Result();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.row_index = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.data = reader.double();
          continue;
        }
        case 3: {
          if (tag !== 25) {
            break;
          }

          message.benchmark = reader.double();
          continue;
        }
        case 4: {
          if (tag !== 33) {
            break;
          }

          message.norm_benchmark = reader.double();
          continue;
        }
        case 5: {
          if (tag !== 41) {
            break;
          }

          message.variance = reader.double();
          continue;
        }
        case 6: {
          if (tag !== 49) {
            break;
          }

          message.contribution_percent = reader.double();
          continue;
        }
        case 7: {
          if (tag !== 57) {
            break;
          }

          message.lastN_period_average = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BenchmarkAnalysisResult_Result {
    return {
      row_index: isSet(object.row_index) ? globalThis.Number(object.row_index) : undefined,
      data: isSet(object.data) ? globalThis.Number(object.data) : undefined,
      benchmark: isSet(object.benchmark) ? globalThis.Number(object.benchmark) : undefined,
      norm_benchmark: isSet(object.norm_benchmark) ? globalThis.Number(object.norm_benchmark) : undefined,
      variance: isSet(object.variance) ? globalThis.Number(object.variance) : undefined,
      contribution_percent: isSet(object.contribution_percent)
        ? globalThis.Number(object.contribution_percent)
        : undefined,
      lastN_period_average: isSet(object.lastN_period_average)
        ? globalThis.Number(object.lastN_period_average)
        : undefined,
    };
  },

  toJSON(message: BenchmarkAnalysisResult_Result): unknown {
    const obj: any = {};
    if (message.row_index !== undefined) {
      obj.row_index = Math.round(message.row_index);
    }
    if (message.data !== undefined) {
      obj.data = message.data;
    }
    if (message.benchmark !== undefined) {
      obj.benchmark = message.benchmark;
    }
    if (message.norm_benchmark !== undefined) {
      obj.norm_benchmark = message.norm_benchmark;
    }
    if (message.variance !== undefined) {
      obj.variance = message.variance;
    }
    if (message.contribution_percent !== undefined) {
      obj.contribution_percent = message.contribution_percent;
    }
    if (message.lastN_period_average !== undefined) {
      obj.lastN_period_average = message.lastN_period_average;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BenchmarkAnalysisResult_Result>, I>>(base?: I): BenchmarkAnalysisResult_Result {
    return BenchmarkAnalysisResult_Result.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BenchmarkAnalysisResult_Result>, I>>(
    object: I,
  ): BenchmarkAnalysisResult_Result {
    const message = createBaseBenchmarkAnalysisResult_Result();
    message.row_index = object.row_index ?? undefined;
    message.data = object.data ?? undefined;
    message.benchmark = object.benchmark ?? undefined;
    message.norm_benchmark = object.norm_benchmark ?? undefined;
    message.variance = object.variance ?? undefined;
    message.contribution_percent = object.contribution_percent ?? undefined;
    message.lastN_period_average = object.lastN_period_average ?? undefined;
    return message;
  },
};

function createBaseDriverAnalysisResult(): DriverAnalysisResult {
  return {
    driver_header: undefined,
    benchmark_header: undefined,
    unique_values: undefined,
    results: [],
    mixture_result: undefined,
  };
}

export const DriverAnalysisResult: MessageFns<DriverAnalysisResult> = {
  encode(message: DriverAnalysisResult, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.driver_header !== undefined) {
      Header.encode(message.driver_header, writer.uint32(10).fork()).join();
    }
    if (message.benchmark_header !== undefined) {
      Header.encode(message.benchmark_header, writer.uint32(18).fork()).join();
    }
    if (message.unique_values !== undefined) {
      writer.uint32(24).int32(message.unique_values);
    }
    for (const v of message.results) {
      DriverAnalysisResult_Result.encode(v!, writer.uint32(34).fork()).join();
    }
    if (message.mixture_result !== undefined) {
      writer.uint32(40).int32(message.mixture_result);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DriverAnalysisResult {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDriverAnalysisResult();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.driver_header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.benchmark_header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.unique_values = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.results.push(DriverAnalysisResult_Result.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.mixture_result = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DriverAnalysisResult {
    return {
      driver_header: isSet(object.driver_header) ? Header.fromJSON(object.driver_header) : undefined,
      benchmark_header: isSet(object.benchmark_header) ? Header.fromJSON(object.benchmark_header) : undefined,
      unique_values: isSet(object.unique_values) ? globalThis.Number(object.unique_values) : undefined,
      results: globalThis.Array.isArray(object?.results)
        ? object.results.map((e: any) => DriverAnalysisResult_Result.fromJSON(e))
        : [],
      mixture_result: isSet(object.mixture_result) ? outcomeMixtureFromJSON(object.mixture_result) : undefined,
    };
  },

  toJSON(message: DriverAnalysisResult): unknown {
    const obj: any = {};
    if (message.driver_header !== undefined) {
      obj.driver_header = Header.toJSON(message.driver_header);
    }
    if (message.benchmark_header !== undefined) {
      obj.benchmark_header = Header.toJSON(message.benchmark_header);
    }
    if (message.unique_values !== undefined) {
      obj.unique_values = Math.round(message.unique_values);
    }
    if (message.results?.length) {
      obj.results = message.results.map((e) => DriverAnalysisResult_Result.toJSON(e));
    }
    if (message.mixture_result !== undefined) {
      obj.mixture_result = outcomeMixtureToJSON(message.mixture_result);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DriverAnalysisResult>, I>>(base?: I): DriverAnalysisResult {
    return DriverAnalysisResult.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DriverAnalysisResult>, I>>(object: I): DriverAnalysisResult {
    const message = createBaseDriverAnalysisResult();
    message.driver_header = (object.driver_header !== undefined && object.driver_header !== null)
      ? Header.fromPartial(object.driver_header)
      : undefined;
    message.benchmark_header = (object.benchmark_header !== undefined && object.benchmark_header !== null)
      ? Header.fromPartial(object.benchmark_header)
      : undefined;
    message.unique_values = object.unique_values ?? undefined;
    message.results = object.results?.map((e) => DriverAnalysisResult_Result.fromPartial(e)) || [];
    message.mixture_result = object.mixture_result ?? undefined;
    return message;
  },
};

function createBaseDriverAnalysisResult_Result(): DriverAnalysisResult_Result {
  return {
    driver_value: undefined,
    metric_value: undefined,
    benchmark_value: undefined,
    norm_benchmark_value: undefined,
    variance: undefined,
    variance_contribution: undefined,
    lastN_period_average: undefined,
    diagnostic_result: undefined,
  };
}

export const DriverAnalysisResult_Result: MessageFns<DriverAnalysisResult_Result> = {
  encode(message: DriverAnalysisResult_Result, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.driver_value !== undefined) {
      writer.uint32(10).string(message.driver_value);
    }
    if (message.metric_value !== undefined) {
      writer.uint32(17).double(message.metric_value);
    }
    if (message.benchmark_value !== undefined) {
      writer.uint32(25).double(message.benchmark_value);
    }
    if (message.norm_benchmark_value !== undefined) {
      writer.uint32(33).double(message.norm_benchmark_value);
    }
    if (message.variance !== undefined) {
      writer.uint32(41).double(message.variance);
    }
    if (message.variance_contribution !== undefined) {
      writer.uint32(49).double(message.variance_contribution);
    }
    if (message.lastN_period_average !== undefined) {
      writer.uint32(57).double(message.lastN_period_average);
    }
    if (message.diagnostic_result !== undefined) {
      writer.uint32(64).int32(message.diagnostic_result);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DriverAnalysisResult_Result {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDriverAnalysisResult_Result();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.driver_value = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.metric_value = reader.double();
          continue;
        }
        case 3: {
          if (tag !== 25) {
            break;
          }

          message.benchmark_value = reader.double();
          continue;
        }
        case 4: {
          if (tag !== 33) {
            break;
          }

          message.norm_benchmark_value = reader.double();
          continue;
        }
        case 5: {
          if (tag !== 41) {
            break;
          }

          message.variance = reader.double();
          continue;
        }
        case 6: {
          if (tag !== 49) {
            break;
          }

          message.variance_contribution = reader.double();
          continue;
        }
        case 7: {
          if (tag !== 57) {
            break;
          }

          message.lastN_period_average = reader.double();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.diagnostic_result = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DriverAnalysisResult_Result {
    return {
      driver_value: isSet(object.driver_value) ? globalThis.String(object.driver_value) : undefined,
      metric_value: isSet(object.metric_value) ? globalThis.Number(object.metric_value) : undefined,
      benchmark_value: isSet(object.benchmark_value) ? globalThis.Number(object.benchmark_value) : undefined,
      norm_benchmark_value: isSet(object.norm_benchmark_value)
        ? globalThis.Number(object.norm_benchmark_value)
        : undefined,
      variance: isSet(object.variance) ? globalThis.Number(object.variance) : undefined,
      variance_contribution: isSet(object.variance_contribution)
        ? globalThis.Number(object.variance_contribution)
        : undefined,
      lastN_period_average: isSet(object.lastN_period_average)
        ? globalThis.Number(object.lastN_period_average)
        : undefined,
      diagnostic_result: isSet(object.diagnostic_result)
        ? diagnosticStatusFromJSON(object.diagnostic_result)
        : undefined,
    };
  },

  toJSON(message: DriverAnalysisResult_Result): unknown {
    const obj: any = {};
    if (message.driver_value !== undefined) {
      obj.driver_value = message.driver_value;
    }
    if (message.metric_value !== undefined) {
      obj.metric_value = message.metric_value;
    }
    if (message.benchmark_value !== undefined) {
      obj.benchmark_value = message.benchmark_value;
    }
    if (message.norm_benchmark_value !== undefined) {
      obj.norm_benchmark_value = message.norm_benchmark_value;
    }
    if (message.variance !== undefined) {
      obj.variance = message.variance;
    }
    if (message.variance_contribution !== undefined) {
      obj.variance_contribution = message.variance_contribution;
    }
    if (message.lastN_period_average !== undefined) {
      obj.lastN_period_average = message.lastN_period_average;
    }
    if (message.diagnostic_result !== undefined) {
      obj.diagnostic_result = diagnosticStatusToJSON(message.diagnostic_result);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DriverAnalysisResult_Result>, I>>(base?: I): DriverAnalysisResult_Result {
    return DriverAnalysisResult_Result.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DriverAnalysisResult_Result>, I>>(object: I): DriverAnalysisResult_Result {
    const message = createBaseDriverAnalysisResult_Result();
    message.driver_value = object.driver_value ?? undefined;
    message.metric_value = object.metric_value ?? undefined;
    message.benchmark_value = object.benchmark_value ?? undefined;
    message.norm_benchmark_value = object.norm_benchmark_value ?? undefined;
    message.variance = object.variance ?? undefined;
    message.variance_contribution = object.variance_contribution ?? undefined;
    message.lastN_period_average = object.lastN_period_average ?? undefined;
    message.diagnostic_result = object.diagnostic_result ?? undefined;
    return message;
  },
};

function createBaseCorrelationAnalysisResult(): CorrelationAnalysisResult {
  return {
    correlation_header: undefined,
    is_formula: undefined,
    formula_expr: undefined,
    results: [],
    mixture_result: undefined,
  };
}

export const CorrelationAnalysisResult: MessageFns<CorrelationAnalysisResult> = {
  encode(message: CorrelationAnalysisResult, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.correlation_header !== undefined) {
      Header.encode(message.correlation_header, writer.uint32(10).fork()).join();
    }
    if (message.is_formula !== undefined) {
      writer.uint32(16).bool(message.is_formula);
    }
    if (message.formula_expr !== undefined) {
      writer.uint32(26).string(message.formula_expr);
    }
    for (const v of message.results) {
      CorrelationAnalysisResult_Result.encode(v!, writer.uint32(34).fork()).join();
    }
    if (message.mixture_result !== undefined) {
      writer.uint32(40).int32(message.mixture_result);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CorrelationAnalysisResult {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCorrelationAnalysisResult();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.correlation_header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.is_formula = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.formula_expr = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.results.push(CorrelationAnalysisResult_Result.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.mixture_result = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CorrelationAnalysisResult {
    return {
      correlation_header: isSet(object.correlation_header) ? Header.fromJSON(object.correlation_header) : undefined,
      is_formula: isSet(object.is_formula) ? globalThis.Boolean(object.is_formula) : undefined,
      formula_expr: isSet(object.formula_expr) ? globalThis.String(object.formula_expr) : undefined,
      results: globalThis.Array.isArray(object?.results)
        ? object.results.map((e: any) => CorrelationAnalysisResult_Result.fromJSON(e))
        : [],
      mixture_result: isSet(object.mixture_result) ? outcomeMixtureFromJSON(object.mixture_result) : undefined,
    };
  },

  toJSON(message: CorrelationAnalysisResult): unknown {
    const obj: any = {};
    if (message.correlation_header !== undefined) {
      obj.correlation_header = Header.toJSON(message.correlation_header);
    }
    if (message.is_formula !== undefined) {
      obj.is_formula = message.is_formula;
    }
    if (message.formula_expr !== undefined) {
      obj.formula_expr = message.formula_expr;
    }
    if (message.results?.length) {
      obj.results = message.results.map((e) => CorrelationAnalysisResult_Result.toJSON(e));
    }
    if (message.mixture_result !== undefined) {
      obj.mixture_result = outcomeMixtureToJSON(message.mixture_result);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CorrelationAnalysisResult>, I>>(base?: I): CorrelationAnalysisResult {
    return CorrelationAnalysisResult.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CorrelationAnalysisResult>, I>>(object: I): CorrelationAnalysisResult {
    const message = createBaseCorrelationAnalysisResult();
    message.correlation_header = (object.correlation_header !== undefined && object.correlation_header !== null)
      ? Header.fromPartial(object.correlation_header)
      : undefined;
    message.is_formula = object.is_formula ?? undefined;
    message.formula_expr = object.formula_expr ?? undefined;
    message.results = object.results?.map((e) => CorrelationAnalysisResult_Result.fromPartial(e)) || [];
    message.mixture_result = object.mixture_result ?? undefined;
    return message;
  },
};

function createBaseCorrelationAnalysisResult_Result(): CorrelationAnalysisResult_Result {
  return {
    related_header: undefined,
    related_value: undefined,
    benchmark_value: undefined,
    variance: undefined,
    variance_contribution: undefined,
    lastN_period_average: undefined,
    diagnostic_result: undefined,
  };
}

export const CorrelationAnalysisResult_Result: MessageFns<CorrelationAnalysisResult_Result> = {
  encode(message: CorrelationAnalysisResult_Result, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.related_header !== undefined) {
      Header.encode(message.related_header, writer.uint32(10).fork()).join();
    }
    if (message.related_value !== undefined) {
      writer.uint32(17).double(message.related_value);
    }
    if (message.benchmark_value !== undefined) {
      writer.uint32(25).double(message.benchmark_value);
    }
    if (message.variance !== undefined) {
      writer.uint32(33).double(message.variance);
    }
    if (message.variance_contribution !== undefined) {
      writer.uint32(41).double(message.variance_contribution);
    }
    if (message.lastN_period_average !== undefined) {
      writer.uint32(49).double(message.lastN_period_average);
    }
    if (message.diagnostic_result !== undefined) {
      writer.uint32(56).int32(message.diagnostic_result);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CorrelationAnalysisResult_Result {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCorrelationAnalysisResult_Result();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.related_header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.related_value = reader.double();
          continue;
        }
        case 3: {
          if (tag !== 25) {
            break;
          }

          message.benchmark_value = reader.double();
          continue;
        }
        case 4: {
          if (tag !== 33) {
            break;
          }

          message.variance = reader.double();
          continue;
        }
        case 5: {
          if (tag !== 41) {
            break;
          }

          message.variance_contribution = reader.double();
          continue;
        }
        case 6: {
          if (tag !== 49) {
            break;
          }

          message.lastN_period_average = reader.double();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.diagnostic_result = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CorrelationAnalysisResult_Result {
    return {
      related_header: isSet(object.related_header) ? Header.fromJSON(object.related_header) : undefined,
      related_value: isSet(object.related_value) ? globalThis.Number(object.related_value) : undefined,
      benchmark_value: isSet(object.benchmark_value) ? globalThis.Number(object.benchmark_value) : undefined,
      variance: isSet(object.variance) ? globalThis.Number(object.variance) : undefined,
      variance_contribution: isSet(object.variance_contribution)
        ? globalThis.Number(object.variance_contribution)
        : undefined,
      lastN_period_average: isSet(object.lastN_period_average)
        ? globalThis.Number(object.lastN_period_average)
        : undefined,
      diagnostic_result: isSet(object.diagnostic_result)
        ? diagnosticStatusFromJSON(object.diagnostic_result)
        : undefined,
    };
  },

  toJSON(message: CorrelationAnalysisResult_Result): unknown {
    const obj: any = {};
    if (message.related_header !== undefined) {
      obj.related_header = Header.toJSON(message.related_header);
    }
    if (message.related_value !== undefined) {
      obj.related_value = message.related_value;
    }
    if (message.benchmark_value !== undefined) {
      obj.benchmark_value = message.benchmark_value;
    }
    if (message.variance !== undefined) {
      obj.variance = message.variance;
    }
    if (message.variance_contribution !== undefined) {
      obj.variance_contribution = message.variance_contribution;
    }
    if (message.lastN_period_average !== undefined) {
      obj.lastN_period_average = message.lastN_period_average;
    }
    if (message.diagnostic_result !== undefined) {
      obj.diagnostic_result = diagnosticStatusToJSON(message.diagnostic_result);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CorrelationAnalysisResult_Result>, I>>(
    base?: I,
  ): CorrelationAnalysisResult_Result {
    return CorrelationAnalysisResult_Result.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CorrelationAnalysisResult_Result>, I>>(
    object: I,
  ): CorrelationAnalysisResult_Result {
    const message = createBaseCorrelationAnalysisResult_Result();
    message.related_header = (object.related_header !== undefined && object.related_header !== null)
      ? Header.fromPartial(object.related_header)
      : undefined;
    message.related_value = object.related_value ?? undefined;
    message.benchmark_value = object.benchmark_value ?? undefined;
    message.variance = object.variance ?? undefined;
    message.variance_contribution = object.variance_contribution ?? undefined;
    message.lastN_period_average = object.lastN_period_average ?? undefined;
    message.diagnostic_result = object.diagnostic_result ?? undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
